<template>
    <div>
        <!-- modal del Lector -->
            <v-dialog v-model="estadoComp" persistent scrollable max-width="100%">
                <v-card>
                    <v-card-title class="modal_title py-5 mb-2">
                        <v-row class="d-flex justify-space-between py-0"> 
                            {{ formTitle }} - ({{ parametros.fileDesc }})
                            <v-btn fab dark x-small class="btn_style3" @click="$emit('close')"><v-icon dark>fa-times</v-icon></v-btn>
                        </v-row>
                    </v-card-title> 

                    <v-divider></v-divider>

                    <v-card-text>
                        <embed v-if="parametros.file_ext=='.pdf'" :src="parametros.fileLink" type="application/pdf" width="100%" height="800px"/>                      
                        <iframe v-else :src="parametros.fileLink" width="100%" height="800px"></iframe>                      
                    </v-card-text>

                    <v-divider></v-divider>

                    
                    <span v-if="test">
                        <code>parametros  {{JSON.stringify(parametros.item)}} </code> <br>
                     
                    </span>

                </v-card>
               
            </v-dialog>
        <!-- fin modal del lector -->
    </div>
</template>

<script>
    import{API_URL} from "@/helpers/axios"
    import {mapMutations, mapGetters, mapActions} from 'vuex';


    export default {
        name:'resource',

        props:{
            parametros:{
                type:Object
            },
            estadoComp:{
                type:Boolean
            },
        
        },
        
        components:{ }, 
        data: () => ({
            //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
            paramComponente:{ 'id_submodulo':1, "id_modulo": 4}, //sud_modulo y modulo
            datoLogin: sessionStorage, // variables de sesion del usuario
            test: false, 
            ////////////////////////////////////////////////////////

            rutaServer: API_URL,
        }),


        //computadas
        computed: {
            ...mapGetters('login', [ 'componenteEvento']),

            formTitle () {
                return 'LECTOR'
            },        
       
        },


        mounted() {
            this.LoadMain()
        },


        created(){
            this.actualizarParamentro()
        },

        
        watch: {
            // cada vez que la pregunta cambie, esta función será ejecutada
            estadoComp() {
                if(this.estadoComp){
                    this.LoadMain()                    
                }else{   
                    //this.parametros = {}
                    this.LimpiarForm()                 
                }                
            }
        },


        methods: {
            //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA //////////////////////
            // -- Validar accesos por perfil ------------
            ...mapActions('login',['parametroComponente'] ),
            actualizarParamentro() {
                this.parametroComponente(this.paramComponente)
            },


            //  ------- MENSAJE DE SISTEMA  --------
            ...mapMutations('mensajeSis', ['setEnviarMens']),
            ////////////////////////////////////////////////////////


            //-- cargar Parametros de inicio del componente --
            async LoadMain(){
                this.LimpiarForm()
            },

            LimpiarForm(){
            },
        },

    }
</script>

<style scoped>
</style>